/* Non-Overriding Self Executing Code */
(function () {

    /* Init: Select First Available Size */
    const variantPicker = document.querySelector('#variant-picker')
    variantPicker.addEventListener('change', () => subscribe('product-info:complete', wyn_selectFirstAvailableSize.bind(variantPicker) ) )

}())


/***
 ** Description: Selects first available size when previously selected is not available
 **  Why this exists: Only when a size is picked can the media matching the selected color will display to the screen. In other words, if say 'xs' was picked previously but is not available in the new color, the correct color image won't be displayed
 **  Category: Variant Selector Patch
*/

function wyn_selectFirstAvailableSize ( e ) {

    //console.log("selectFirstAvailableSize",this)

    const checkedSize = this.querySelector('.option-size input:checked')
    //console.log('checkedSize',checkedSize)

    if ( checkedSize.classList.contains('disabled') ) {

        // Selects the first found not disabled
        const firstAvailableSize = checkedSize.parentElement.querySelector('input:not(.disabled)')

        if ( firstAvailableSize )
        firstAvailableSize.click();
    }

}